// src/components/CustomerReview.js
import React, { useState } from 'react';
import './CustomerReview.css';

import review1 from "./assets/review-1.jpg";
import review2 from "./assets/review-2.jpg";
import review3 from "./assets/review-3.jpg";
import review4 from "./assets/review-4.jpg";
import review5 from "./assets/review-5.jpg";
import review6 from "./assets/review-6.jpg";
import review7 from "./assets/review-7.jpg";
import review8 from "./assets/review-8.jpg";
import review9 from "./assets/review-9.jpg";
import review10 from "./assets/review-10.jpg";
import review11 from "./assets/review-11.jpg";
import review12 from "./assets/review-12.jpg";

import review1video from "./assets/review-1.mp4";
import review2video from "./assets/review-2.mp4";
import review3video from "./assets/review-3.mp4";
import review4video from "./assets/review-4.mp4";
import review5video from "./assets/review-5.mp4";
import review6video from "./assets/review-6.mp4";
import review7video from "./assets/review-7.mp4";
import review8video from "./assets/review-8.mp4";
import review9video from "./assets/review-9.mp4";
import review10video from "./assets/review-10.mp4";
import review11video from "./assets/review-11.mp4";
import review12video from "./assets/review-12.mp4";

const CustomerReview = () => {
  const [popupVideo, setPopupVideo] = useState(null);

  const reviews = [
    { img: review1, video: review1video },
    { img: review2, video: review2video },
    { img: review3, video: review3video },
    { img: review4, video: review4video },
    { img: review5, video: review5video },
    { img: review6, video: review6video },
    { img: review7, video: review7video },
    { img: review8, video: review8video },
    { img: review9, video: review9video },
    { img: review10, video: review10video },
    { img: review11, video: review11video },
    { img: review12, video: review12video },
  ];

  return (
    <main className="main-box allmain">
      <h2 className="carousel-heading">Customer Reviews</h2>
      <div className="grid-container">
        {reviews.map((item, index) => (
          <div className="grid-item" key={index}>
            <div className="thumbnail-wrapper">
              <img
                src={item.img}
                alt={`Review ${index + 1}`}
                onClick={() => setPopupVideo(item.video)}
              />
              <div className="play-icon">&#9658;</div>
            </div>
          </div>
        ))}
      </div>

      {popupVideo && (
        <div className="popup">
          <span className="close" onClick={() => setPopupVideo(null)}>&times;</span>
          <iframe
            className="popup-content"
            src={popupVideo}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Popup Video"
          ></iframe>
        </div>
      )}
    </main>
  );
};

export default CustomerReview;
